import { useEffect, useState } from "react"


export const ScrollTop = () => {

    const [scrollTopButton, setScrollTopButton] = useState(false);

    useEffect(() => {
      
        window.addEventListener("scroll", () => {
            if(window.scrollY > 100){
                setScrollTopButton(true)
            }else {
                setScrollTopButton(false)
            }
        })

    }, [])
    

    const scrollUp = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        })
    }

  return (
    <div>
        
        {scrollTopButton &&(
            <button 
                className="btn_scrollTop"
                onClick={scrollUp}
            >
                <i className="fa-solid fa-angle-up"></i>
            </button>
        )}
        
    </div>
  )
}
